import { render, staticRenderFns } from "./StaticTemplate.vue?vue&type=template&id=1fff2d76"
import script from "./StaticTemplate.vue?vue&type=script&lang=js"
export * from "./StaticTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports